import types from './types';

const loadPhotoSeriesSuccess = (photoSeriesId, data) => ({
  type: types.LOAD_PHOTO_SERIES_SUCCESS,
  payload: {
    photoSeriesId,
    data
  },
});

const loadPhotoSeriesDamageSummarySuccess = (photoSeriesId, data) => ({
  type: types.LOAD_PHOTO_SERIES_DAMAGE_SUMMARY_SUCCESS,
  payload: {
    photoSeriesId,
    data
  }
});

const loadPhotoSeriesRepairEstimationsSuccess = (photoSeriesId, data) => ({
  type: types.LOAD_PHOTO_SERIES_REPAIR_ESTIMATIONS_SUCCESS,
  payload: {
    photoSeriesId,
    data
  }
});

const loadPhotoSeriesReportStatusSuccess = (photoSeriesId, data) => ({
  type: types.LOAD_PHOTO_SERIES_REPORT_STATUS_SUCCESS,
  payload: {
    photoSeriesId,
    data
  }
});

const updateRepairEstimationProductInfoSuccess = (photoSeriesId, bodyPart, productInfo) => ({
  type: types.UPDATE_REPAIR_ESTIMATION_PRODUCT_INFO_SUCCESS,
  payload: {
    photoSeriesId,
    bodyPart,
    productInfo
  }
});

const updateRepairDecisionSuccess = (photoSeriesId, data) => ({
  type: types.UPDATE_REPAIR_DECISION_SUCCESS,
  payload: {
    photoSeriesId,
    data
  }
});

export default {
  loadPhotoSeriesSuccess,
  loadPhotoSeriesDamageSummarySuccess,
  loadPhotoSeriesRepairEstimationsSuccess,
  loadPhotoSeriesReportStatusSuccess,
  updateRepairEstimationProductInfoSuccess,
  updateRepairDecisionSuccess
};
